module.exports = __webpack_public_path__ + "static/media/magisk.7311c52d.mp3";